import type { QueueItem } from './types'

/** No library track in the queue can seed a similarity query. */
export const NO_SEED = -1

export interface RadioSeeds {
  /** Track id for artist/tag similarity (Last.fm). */
  seedId: number
  /** Track id for mood/embedding similarity — needs an analyzed track. */
  moodSeedId: number
}

/**
 * Pure function: pick the track ids radio should seed its similarity queries from.
 *
 * The playhead itself often can't seed one. Interstitials live in a different
 * table, so their ids aren't track ids and querying them 404s. Unanalyzed tracks
 * have no mood vector — a null tempo is a reliable proxy. Both fall back to the
 * nearest preceding track that qualifies; `moodSeedId` degrades to `seedId` when
 * nothing analyzed is in reach.
 */
export function resolveRadioSeeds(queue: QueueItem[], currentIndex: number): RadioSeeds {
  let seedId = NO_SEED
  let moodSeedId = NO_SEED

  for (let i = Math.min(currentIndex, queue.length - 1); i >= 0; i--) {
    const track = queue[i]
    if (!track || track.isInterstitial) continue
    if (seedId === NO_SEED) seedId = track.id
    if (track.tempo !== null) {
      moodSeedId = track.id
      break
    }
  }

  return { seedId, moodSeedId: moodSeedId === NO_SEED ? seedId : moodSeedId }
}
